export var Dialog;
(function (Dialog) {
    Dialog[Dialog["Closed"] = 1] = "Closed";
    Dialog[Dialog["Purchased"] = 2] = "Purchased";
})(Dialog || (Dialog = {}));
export var DisplayInfoResolutions;
(function (DisplayInfoResolutions) {
    DisplayInfoResolutions["Res_2K"] = "2K";
    DisplayInfoResolutions["Res_4k"] = "4K";
    DisplayInfoResolutions["Unknown"] = "unknown";
})(DisplayInfoResolutions || (DisplayInfoResolutions = {}));
export var DisplayInfoDynamicRange;
(function (DisplayInfoDynamicRange) {
    DisplayInfoDynamicRange["HDR"] = "HDR";
    DisplayInfoDynamicRange["SDR"] = "SDR";
    DisplayInfoDynamicRange["Unknown"] = "unknown";
})(DisplayInfoDynamicRange || (DisplayInfoDynamicRange = {}));
export var DisplayInfoHdcpVersion;
(function (DisplayInfoHdcpVersion) {
    DisplayInfoHdcpVersion["HDCP_1.4"] = "1.4";
    DisplayInfoHdcpVersion["HDCP_2.3"] = "2.3";
    DisplayInfoHdcpVersion["None"] = "none";
})(DisplayInfoHdcpVersion || (DisplayInfoHdcpVersion = {}));
export var DisplayInfoRefreshRate;
(function (DisplayInfoRefreshRate) {
    DisplayInfoRefreshRate["120Hz"] = "119.88";
    DisplayInfoRefreshRate["60Hz"] = "59.94";
    DisplayInfoRefreshRate["Unknown"] = "unknown";
})(DisplayInfoRefreshRate || (DisplayInfoRefreshRate = {}));
export var ShareSetStatus;
(function (ShareSetStatus) {
    ShareSetStatus[ShareSetStatus["Permit"] = 0] = "Permit";
    ShareSetStatus[ShareSetStatus["Prohibit"] = 1] = "Prohibit";
})(ShareSetStatus || (ShareSetStatus = {}));
export var ShareGetStatus;
(function (ShareGetStatus) {
    ShareGetStatus[ShareGetStatus["NotEnabled"] = 0] = "NotEnabled";
    ShareGetStatus[ShareGetStatus["Paused"] = 1] = "Paused";
    ShareGetStatus[ShareGetStatus["Running"] = 2] = "Running";
})(ShareGetStatus || (ShareGetStatus = {}));
export var ShareFeature;
(function (ShareFeature) {
    ShareFeature[ShareFeature["VideoRecording"] = 1] = "VideoRecording";
    ShareFeature[ShareFeature["ScreenShot"] = 2] = "ScreenShot";
    ShareFeature[ShareFeature["Broadcast"] = 4] = "Broadcast";
    ShareFeature[ShareFeature["RemotePlay"] = 8] = "RemotePlay";
    ShareFeature[ShareFeature["SharePlay"] = 16] = "SharePlay";
})(ShareFeature || (ShareFeature = {}));
export var TextSize;
(function (TextSize) {
    TextSize[TextSize["Small"] = -1] = "Small";
    TextSize[TextSize["Normal"] = 0] = "Normal";
    TextSize[TextSize["Large"] = 1] = "Large";
    TextSize[TextSize["VeryLarge"] = 2] = "VeryLarge";
})(TextSize || (TextSize = {}));
export var MarqueeSpeed;
(function (MarqueeSpeed) {
    MarqueeSpeed[MarqueeSpeed["VerySlow"] = -2] = "VerySlow";
    MarqueeSpeed[MarqueeSpeed["Slow"] = -1] = "Slow";
    MarqueeSpeed[MarqueeSpeed["Normal"] = 0] = "Normal";
    MarqueeSpeed[MarqueeSpeed["Fast"] = 1] = "Fast";
})(MarqueeSpeed || (MarqueeSpeed = {}));
export var LongPressTime;
(function (LongPressTime) {
    LongPressTime[LongPressTime["Normal"] = 0] = "Normal";
    LongPressTime[LongPressTime["Long"] = 1] = "Long";
})(LongPressTime || (LongPressTime = {}));
export var ClosedCaptionFont;
(function (ClosedCaptionFont) {
    ClosedCaptionFont[ClosedCaptionFont["MonoSerif"] = 0] = "MonoSerif";
    ClosedCaptionFont[ClosedCaptionFont["ProportionallySerif"] = 1] = "ProportionallySerif";
    ClosedCaptionFont[ClosedCaptionFont["MonoSanSerif"] = 2] = "MonoSanSerif";
    ClosedCaptionFont[ClosedCaptionFont["ProportionallySanSerif"] = 3] = "ProportionallySanSerif";
    ClosedCaptionFont[ClosedCaptionFont["Casual"] = 4] = "Casual";
    ClosedCaptionFont[ClosedCaptionFont["Cursive"] = 5] = "Cursive";
    ClosedCaptionFont[ClosedCaptionFont["SmallCapitals"] = 6] = "SmallCapitals";
})(ClosedCaptionFont || (ClosedCaptionFont = {}));
// Docs imply that there are only set colors allowed
export var ClosedCaptionColor;
(function (ClosedCaptionColor) {
    ClosedCaptionColor[ClosedCaptionColor["White"] = 131586] = "White";
    ClosedCaptionColor[ClosedCaptionColor["Black"] = 0] = "Black";
    ClosedCaptionColor[ClosedCaptionColor["Red"] = 131072] = "Red";
    ClosedCaptionColor[ClosedCaptionColor["Green"] = 512] = "Green";
    ClosedCaptionColor[ClosedCaptionColor["Blue"] = 2] = "Blue";
    ClosedCaptionColor[ClosedCaptionColor["Yellow"] = 131584] = "Yellow";
    ClosedCaptionColor[ClosedCaptionColor["Magenta"] = 131074] = "Magenta";
    ClosedCaptionColor[ClosedCaptionColor["Cyan"] = 514] = "Cyan";
})(ClosedCaptionColor || (ClosedCaptionColor = {}));
export var ClosedCaptionEdges;
(function (ClosedCaptionEdges) {
    ClosedCaptionEdges[ClosedCaptionEdges["None"] = 0] = "None";
    ClosedCaptionEdges[ClosedCaptionEdges["Raised"] = 1] = "Raised";
    ClosedCaptionEdges[ClosedCaptionEdges["Depressed"] = 2] = "Depressed";
    ClosedCaptionEdges[ClosedCaptionEdges["Uniform"] = 3] = "Uniform";
    ClosedCaptionEdges[ClosedCaptionEdges["DropShadowed"] = 4] = "DropShadowed";
})(ClosedCaptionEdges || (ClosedCaptionEdges = {}));
export var TextToSpeechSpeed;
(function (TextToSpeechSpeed) {
    TextToSpeechSpeed[TextToSpeechSpeed["Slow"] = -1] = "Slow";
    TextToSpeechSpeed[TextToSpeechSpeed["Normal"] = 0] = "Normal";
    TextToSpeechSpeed[TextToSpeechSpeed["Fast"] = 1] = "Fast";
})(TextToSpeechSpeed || (TextToSpeechSpeed = {}));
export var TextToSpeechVoice;
(function (TextToSpeechVoice) {
    TextToSpeechVoice[TextToSpeechVoice["Male"] = 0] = "Male";
    TextToSpeechVoice[TextToSpeechVoice["Female"] = 1] = "Female";
})(TextToSpeechVoice || (TextToSpeechVoice = {}));
//# sourceMappingURL=prospero-window.js.map